import {
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Area,
  ResponsiveContainer,
  ComposedChart,
} from 'recharts';

export const SupportingChart = () => {
  const data = [
    { time: '11:22', count: 52 },
    { time: '11:24', count: 48 },
    { time: '11:27', count: 65 },
    { time: '11:29', count: 68 },
    { time: '11:32', count: 78 },
    { time: '11:34', count: 72 },
    { time: '11:37', count: 78 },
    { time: '11:39', count: 65 },
    { time: '11:42', count: 62 },
    { time: '11:44', count: 65 },
    { time: '11:45', count: 68, highlighted: true },
    { time: '11:46', count: 115, highlighted: true },
    { time: '11:47', count: 118, highlighted: true },
    { time: '11:48', count: 105, highlighted: true },
    { time: '11:49', count: 62 },
  ];

  return (
    <div
      style={{
        width: '100%',
        height: '400px',
      }}
    >
      <ResponsiveContainer width="100%" height={400}>
        <ComposedChart
          data={data}
          margin={{ top: 20, right: 70, left: 0, bottom: 20 }}
        >
          <defs>
            <linearGradient id="highlightGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#e8744f" stopOpacity={0.6} />
              <stop offset="95%" stopColor="#6b4a6f" stopOpacity={0.6} />
            </linearGradient>
          </defs>
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="#1e3a5f"
            vertical={false}
          />
          <XAxis
            dataKey="time"
            stroke="#64748b"
            tick={{ fill: '#94a3b8', fontSize: 12 }}
            axisLine={{ stroke: '#1e3a5f' }}
          />
          <YAxis
            stroke="#64748b"
            tick={{ fill: '#94a3b8', fontSize: 12 }}
            axisLine={{ stroke: '#1e3a5f' }}
            label={{
              value: 'Engine Heating Coolant',
              angle: -90,
              position: 'insideLeft',
              fill: '#94a3b8',
              fontSize: 12,
              dy: 60,
              dx: 15,
            }}
          />
          <Area
            type="monotone"
            dataKey={(entry) => (entry.highlighted ? entry.count : null)}
            fill="url(#highlightGradient)"
            stroke="none"
          />
          <Line
            type="monotone"
            dataKey="count"
            stroke="#f59e42"
            strokeWidth={2.5}
            dot={false}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};
